<template>
   
   <div style="" class="text-center" id="footerContent">
       <div id="buttonGroups">
          <div>
           <button @click="$emit('showRejectScreen')" v-show="VacationData.VacationDetail[0].status == InProgressStatus && isApprover && isCanBeApproveMySelf" id="btnReject" class="mr-2 mb-2">{{ $t("vacation_detail_reject") }}</button>
           <button @click="$emit('showApproveScreen')" v-show="VacationData.VacationDetail[0].status == InProgressStatus && isApprover && isCanBeApproveMySelf" id="btnApprove" class="mr-2 mb-2">{{ $t("vacation_detail_approve") }}</button>
          </div>
          <div>
           <button @click="$emit('showDeleteDialog')" v-show="(VacationData.VacationDetail[0].status == InProgressStatus && isOwnCreator) || (VacationData.VacationDetail[0].status == RejectedStatus && isOwnCreator) " id="btnDelete" class="mr-2 mb-2">{{ $t("vacation_detail_delete") }}</button>
           <button v-on:click="editVacation" v-show="VacationData.VacationDetail[0].status == InProgressStatus && isOwnCreator" id="btnEdit" class="mr-2 mb-2">{{ $t("web_edit_vaction") }}</button>
           <button @click="$emit('showDeleteDialog')" v-show="VacationData.VacationDetail[0].status == ApprovedStatus && isOwnCreator && checkDateTimeVaction != -1" id="btnCancel" class="mr-2 mb-2">{{ $t("vacation_detail_delete") }}</button>
          </div>
       </div>
   </div>
</template>
<script> 
   import { mapGetters, mapState } from "vuex";
   import { getUserRole, isApprover} from "@/utilities/CommonUtilities";
   import { ListEvents, compareVacationDate, VacationStatus } from "@/utilities/CommonUtilities";
   export default {  
        name :'FooterVacation',
        props:{
          VacationData: Object
        },
        data () {
            return {
                isApprover: false,
                userInfomation: {},
                test: false,
                countRole: 0,
                InProgressStatus: VacationStatus.InProgress,
                ApprovedStatus: VacationStatus.Approved,
                RejectedStatus: VacationStatus.Rejected,
            }
        },
        computed: {
            ...mapGetters(["getUserByID"]),
            ...mapState(["userInfo"]),
            ...mapState(["listUser", "token", "listReason"]),
            isCanBeApproveMySelf(){
              //  if(this.userInfo.userID != this.VacationData.VacationDetail[0].user_id) return true;
              //  let count = 0;
              //  for(let i=0; i < this.listUser.length; i++) {
              //    let userRole = getUserRole(this.listUser[i].serviceInformation);
              //    if(isApprover(userRole)) count ++;
              //  }
              //  if(count > 1) return false;
              //  else return true;

               return true;
            },
            isOwnCreator(){
              if(this.userInfo.userID == this.VacationData.VacationDetail[0].user_id) return true;
              return false;
            },
            checkDateTimeVaction() {
             return compareVacationDate(this.VacationData.VacationDetail[0].from_date, this.VacationData.VacationDetail[0].to_date)
           },
            
        },
        created() {
           let userRole = getUserRole(this.userInfo.serviceInformation);
           if(isApprover(userRole)) {
             this.isApprover = true;
           } else {
             this.isApprover = false;
          }
        },
        methods: {
           editVacation() {
             this.$router.push('/edit/' + this.VacationData.VacationData.id);
             this.notifyBus.$emit(ListEvents.closeVacationDetail);
           },
        },
        inject: ["dataSource", "notifyBus"],
    }
</script>
<style scoped>
  button{
      width: 200px;
      color: white;
      height: 35px;
      font-size: 16px;
      font-weight: bold;
      border-radius: 2px
  }
  button:focus {outline:0;}
  #btnReject{
      background-color: #E561A9
  }
  #btnApprove{
      background-color: #5E81ED
  }
  #btnEdit{
      background-color: #5E81ED;
  }
  #btnDelete{
      background-color: #E561A9
  }
  #btnCancel{
      background-color: #E561A9
  }
   #footerContent {
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
    font-size: 20px;
}
   @media screen and (max-width: 600px) {
     button{
       width: 120px
    }
 }
</style>
